import { Injectable } from '@angular/core';
import { UserDto } from '@core/common/user-dto';
import { HttpService } from '@core/services/http.service';
import { Store } from '@core/services/store.service';
import { forkJoin, Observable, of } from 'rxjs';
import { tap } from 'rxjs';
import { AuthURL } from '@core/config/auth-url.config';
import { AuthState } from './auth.state';
@Injectable()
export class AuthStore extends Store<AuthState> {
  constructor(private httpService: HttpService) {
    super(new AuthState());
  }

  addAuthInfo(user: UserDto): void {
    this.setState({ ...this.state, user });
  }

  getAuthInfo(): Observable<any> {
    console.log(this.state);
    if (this.state.user) {
      return of(this.state.user);
    } else {
      return forkJoin([this.httpService.get(AuthURL.EndPoints.auth.user.userInfo)]).pipe(
        tap(([user]) => user)
      );
    }
  }
}
